module.exports = __webpack_public_path__ + "img/svg/step3.82203a6ecff1410742d66a81c1125d0e.svg";